import size from 'lodash/size';
import templateUrl from './app-nav-footer.html';

export const navFooterComponent = {
	templateUrl,

	bindings: {
		features: '<'
	},

	controller: class HeaderController {
		constructor($state, $window, $transitions, HomeService, toastr, $location, GoogleAnalytics, ApiService) {
			'ngInject';

			this.$state = $state;
			this.$window = $window;
			this.toastr = toastr;
			this.homeService = HomeService;
			this.googleAnalytics = GoogleAnalytics;
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
			this.$location = $location;
			this.showFooterContact = true;
			this.showFooterContactCallCenter = true;
			this.toastr = toastr;
			this.apiService = ApiService;
		}

		$onInit() {
			//this.dataLayer = this.$window.dataLayer = this.$window.dataLayer || [];
			this.currentYear = new Date().getFullYear();
			this.contactInfo = {};
			this.donationUrl = "";
			this.subscriberEmail = "";
			this.joinButtonDisabled = false;
			this.socialLinks = [];
			this.footerImage = "";
			this._getSocialLinks();
			this._getDonationUrl();
			this._getContactDetails();
			this._getFooterLogo();
		}

		onStateChangeSuccess() {
			const state = this.$state.current;
			this.stateName = this.$state.current.name;
			this.googleAnalytics.pageView();
			const screenWidth = this.$window.innerWidth;
			if (this.stateName === 'CallCenter') {
				this.showFooterContactCallCenter = false;
				this.showFooterContact = false;
			} else if (screenWidth < 768) {
				this.showFooterContact = (this.stateName === 'TransportationServices' || this.stateName === 'VolunteerTransportationPrograms') ? false : true;
			} else {
				this.showFooterContactCallCenter = true;
				this.showFooterContact = true;
			}
		}

		subscribe() {
			if (this.subscriberEmail && size(this.subscriberEmail.trim()) > 0) {
				this.joinButtonDisabled = true;
				this.homeService.addSubscriber({ email: this.subscriberEmail })
					.then(_ => {
						this.toastr.success(`${this.subscriberEmail} is subscribed successfully.`);
						this.subscriberEmail = "";
						this.joinButtonDisabled = false;
					})
					.catch(err => {
						this.toastr.error(err);
						this.joinButtonDisabled = false;
					});
			}
		}

		//*****************************************************PRIVATE METHODS********************************** */

		_getSocialLinks() {
			this.homeService.getSocialLinks()
				.then(socialLinks => this.socialLinks = socialLinks);
		}

		_getDonationUrl() {
			this.homeService.getDonationUrl()
				.then(({ url }) => this.donationUrl = url);
		}

		_getContactDetails() {
			this.homeService.getContactInfoDetails()
				.then(details => this.contactInfo = details);
		}

		_getFooterLogo() {
			this.homeService.getFooterLogo()
				.then(({image}) => {
					this.footerImage = this._getImage(image);
				});
		}

		_getImage(image) {
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav-footer.component.js